var map = {
	"./App": 48310,
	"./App.vue": 48310,
	"./assets/css/anim.scss": 98570,
	"./assets/css/common.scss": 90807,
	"./assets/css/global.scss": 23059,
	"./assets/css/popPrompt.scss": 50082,
	"./assets/css/reset.scss": 12841,
	"./assets/css/utils.scss": 55955,
	"./assets/css/vtip.css": 96714,
	"./assets/fonts/PANTON-BLACK.OTF": 44871,
	"./assets/fonts/POPPINS-MEDIUM.OTF": 75936,
	"./assets/fonts/Poppins-Regular.ttf": 27588,
	"./assets/fonts/Poppins-SemiBold.ttf": 98167,
	"./assets/fonts/font.css": 39399,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-add.svg": 68869,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-close.svg": 50829,
	"./assets/icons/svg/icon-copy.svg": 54171,
	"./assets/icons/svg/icon-edit.svg": 47766,
	"./assets/icons/svg/icon-face.svg": 91183,
	"./assets/icons/svg/icon-friends.svg": 96864,
	"./assets/icons/svg/icon-getgems.svg": 45472,
	"./assets/icons/svg/icon-human.svg": 81415,
	"./assets/icons/svg/icon-level-arrow.svg": 89889,
	"./assets/icons/svg/icon-lucky.svg": 80480,
	"./assets/icons/svg/icon-ok-fill.svg": 78831,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-ok1.svg": 43440,
	"./assets/icons/svg/icon-quit.svg": 24764,
	"./assets/icons/svg/icon-refresh.svg": 82037,
	"./assets/icons/svg/icon-rewards.svg": 84167,
	"./assets/icons/svg/icon-rule.svg": 58085,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/icons/svg/icon-tier.svg": 10676,
	"./assets/icons/svg/icon-time.svg": 94375,
	"./assets/icons/svg/icon-tip.svg": 98117,
	"./assets/icons/svg/icon-twitter.svg": 65765,
	"./assets/icons/svg/icon-up.svg": 33442,
	"./assets/icons/svg/icon-upgrade.svg": 31535,
	"./assets/images/COIN.png": 47208,
	"./assets/images/CRY.png": 51799,
	"./assets/images/GIFTSHARD.png": 40393,
	"./assets/images/LGCOIN.png": 76100,
	"./assets/images/LGSPINS.png": 2176,
	"./assets/images/PASS.png": 32028,
	"./assets/images/SPINS.png": 87415,
	"./assets/images/USDT.png": 17108,
	"./assets/images/airdrop-box-img.png": 52502,
	"./assets/images/airdrop-intro-bg.jpg": 55789,
	"./assets/images/avatar/body/0.png": 20506,
	"./assets/images/avatar/body/1.png": 68290,
	"./assets/images/avatar/body/10.png": 17734,
	"./assets/images/avatar/body/11.png": 81984,
	"./assets/images/avatar/body/12.png": 70939,
	"./assets/images/avatar/body/13.png": 77371,
	"./assets/images/avatar/body/14.png": 13394,
	"./assets/images/avatar/body/15.png": 69540,
	"./assets/images/avatar/body/16.png": 21868,
	"./assets/images/avatar/body/17.png": 96636,
	"./assets/images/avatar/body/18.png": 253,
	"./assets/images/avatar/body/19.png": 83259,
	"./assets/images/avatar/body/2.png": 89494,
	"./assets/images/avatar/body/20.png": 83205,
	"./assets/images/avatar/body/3.png": 93948,
	"./assets/images/avatar/body/4.png": 14567,
	"./assets/images/avatar/body/5.png": 50516,
	"./assets/images/avatar/body/6.png": 39085,
	"./assets/images/avatar/body/7.png": 16668,
	"./assets/images/avatar/body/8.png": 3414,
	"./assets/images/avatar/body/9.png": 64801,
	"./assets/images/avatar/head/0.png": 94779,
	"./assets/images/avatar/head/1.png": 97656,
	"./assets/images/avatar/head/10.png": 27961,
	"./assets/images/avatar/head/11.png": 37123,
	"./assets/images/avatar/head/12.png": 97476,
	"./assets/images/avatar/head/13.png": 39227,
	"./assets/images/avatar/head/14.png": 91867,
	"./assets/images/avatar/head/15.png": 82950,
	"./assets/images/avatar/head/16.png": 19891,
	"./assets/images/avatar/head/17.png": 86674,
	"./assets/images/avatar/head/18.png": 4938,
	"./assets/images/avatar/head/19.png": 15491,
	"./assets/images/avatar/head/2.png": 47683,
	"./assets/images/avatar/head/20.png": 11410,
	"./assets/images/avatar/head/3.png": 76033,
	"./assets/images/avatar/head/4.png": 67688,
	"./assets/images/avatar/head/5.png": 5665,
	"./assets/images/avatar/head/6.png": 65219,
	"./assets/images/avatar/head/7.png": 67468,
	"./assets/images/avatar/head/8.png": 50344,
	"./assets/images/avatar/head/9.png": 25028,
	"./assets/images/avatar/pet/1.png": 60997,
	"./assets/images/avatar/pet/2.png": 20390,
	"./assets/images/avatar/pet/3.png": 70497,
	"./assets/images/avatar/pet/4.png": 4656,
	"./assets/images/avatar/pet/5.png": 28114,
	"./assets/images/avatar/pet/6.png": 39373,
	"./assets/images/botcode/botcode-bg.jpg": 3493,
	"./assets/images/botcode/game-banner.jpg": 20730,
	"./assets/images/botcode/game-icon-bg.png": 11343,
	"./assets/images/botcode/game-icon-restart.png": 40307,
	"./assets/images/botcode/game-item-bg-icon.png": 61217,
	"./assets/images/botcode/game-item-bg.png": 23019,
	"./assets/images/botcode/game-item-ok-bg.png": 29761,
	"./assets/images/botcode/game-item-select-bg.png": 97136,
	"./assets/images/botcode/game-reward-bg.png": 23605,
	"./assets/images/botcode/game-title-bg.png": 23594,
	"./assets/images/botcode/icon-buy.png": 30930,
	"./assets/images/botcode/icon-invite.png": 56299,
	"./assets/images/botcode/icon-lucky.png": 64254,
	"./assets/images/botcode/icon-task.png": 61332,
	"./assets/images/botcode/option-bg.jpg": 14313,
	"./assets/images/buySpineItemBg1.png": 99267,
	"./assets/images/buySpineItemBg2-tag.png": 71666,
	"./assets/images/buySpineItemBg2.png": 23474,
	"./assets/images/buySpineItemBg3-tag.png": 37315,
	"./assets/images/buySpineItemBg3.png": 20463,
	"./assets/images/card-bg.png": 91049,
	"./assets/images/center-item-bg.png": 65721,
	"./assets/images/firend-intro-bg.jpg": 27476,
	"./assets/images/guide/guide-icon-arrow.png": 45170,
	"./assets/images/guide/guide-img-botcode.jpg": 77444,
	"./assets/images/guide/guide-img-slot.jpg": 59295,
	"./assets/images/guide/guide-img-turn.jpg": 64402,
	"./assets/images/icon-bonus.png": 20919,
	"./assets/images/icon-firend.png": 25011,
	"./assets/images/icon-gift-small.png": 34664,
	"./assets/images/icon-gift.png": 82043,
	"./assets/images/icon-lock-small.png": 69220,
	"./assets/images/icon-rank.png": 50115,
	"./assets/images/icon-stock.png": 41174,
	"./assets/images/icon-upgrade.png": 98094,
	"./assets/images/icon/icon-account.png": 9380,
	"./assets/images/icon/icon-discord.png": 848,
	"./assets/images/icon/icon-dogs.png": 98726,
	"./assets/images/icon/icon-extend.png": 73076,
	"./assets/images/icon/icon-giftshare.png": 13218,
	"./assets/images/icon/icon-hic.png": 23652,
	"./assets/images/icon/icon-human.png": 60886,
	"./assets/images/icon/icon-invite.png": 90831,
	"./assets/images/icon/icon-login.png": 98886,
	"./assets/images/icon/icon-menu.png": 97889,
	"./assets/images/icon/icon-moves.png": 66085,
	"./assets/images/icon/icon-pass.png": 44974,
	"./assets/images/icon/icon-slots.png": 5646,
	"./assets/images/icon/icon-spins.png": 96005,
	"./assets/images/icon/icon-star-fill.png": 66436,
	"./assets/images/icon/icon-star.png": 71923,
	"./assets/images/icon/icon-star2.png": 89626,
	"./assets/images/icon/icon-telegram.png": 63177,
	"./assets/images/icon/icon-time.png": 87772,
	"./assets/images/icon/icon-ton.png": 35048,
	"./assets/images/icon/icon-twitter.png": 39457,
	"./assets/images/icon/icon-up.png": 41868,
	"./assets/images/icon/icon-usdt.png": 84138,
	"./assets/images/index-bg.jpg": 3954,
	"./assets/images/loading-bg.jpg": 29093,
	"./assets/images/login-sign.jpg": 90018,
	"./assets/images/logo.jpg": 69218,
	"./assets/images/lucky-bg.jpg": 87911,
	"./assets/images/lucky-icon-airdrop.jpg": 30640,
	"./assets/images/lucky-icon-botcode.jpg": 29209,
	"./assets/images/lucky-icon-gift.jpg": 86240,
	"./assets/images/lucky-icon-lucky.jpg": 2810,
	"./assets/images/lucky-icon-mathine.jpg": 70266,
	"./assets/images/lucky-icon-minibot.jpg": 22454,
	"./assets/images/lucky/lucky-8-item-1.png": 85746,
	"./assets/images/lucky/lucky-8-item-2.png": 79475,
	"./assets/images/lucky/lucky-bg.png": 27200,
	"./assets/images/lucky/lucky-btn1-bg.png": 16436,
	"./assets/images/lucky/lucky-btn1-text.png": 81615,
	"./assets/images/lucky/lucky-page-bg.jpg": 43459,
	"./assets/images/mUpgrade-item-bg.png": 93059,
	"./assets/images/machine/machine-arrow.png": 17409,
	"./assets/images/machine/machine-bg.png": 69303,
	"./assets/images/machine/machine-btn1-bg.png": 37724,
	"./assets/images/machine/machine-main-bg.png": 71890,
	"./assets/images/machine/machine-page-bg.jpg": 56769,
	"./assets/images/minibot/minibot-bg.jpg": 45706,
	"./assets/images/minibot/minibot-store.png": 37087,
	"./assets/images/minibot/minibot-store1.png": 92968,
	"./assets/images/minibot/pet-bg.jpg": 40896,
	"./assets/images/multiple-img.png": 6682,
	"./assets/images/pass/pass-bg.jpg": 43280,
	"./assets/images/pass/pass-progree-item-active.png": 18593,
	"./assets/images/pass/pass-progree-item.png": 15304,
	"./assets/images/pass/pass-way-bg.jpg": 39223,
	"./assets/images/rank-1.png": 67023,
	"./assets/images/rank-2.png": 99933,
	"./assets/images/rank-3.png": 56036,
	"./assets/images/reward-bg.jpg": 91835,
	"./assets/images/rewardAnim/anim-1.png": 58044,
	"./assets/images/rewardAnim/anim-2.png": 36753,
	"./assets/images/rewardAnim/anim-bg-COIN.png": 62208,
	"./assets/images/ris/ris-a-img.png": 6029,
	"./assets/images/ris/ris-c-img-1.png": 65437,
	"./assets/images/ris/ris-c-img-2.png": 96199,
	"./assets/images/turmp.png": 47334,
	"./assets/images/upgrade-bot-bg.jpg": 57835,
	"./assets/images/upgrade-bot-bg2.jpg": 48665,
	"./assets/images/upgrade-box.png": 12327,
	"./assets/js/Mining": 26214,
	"./assets/js/Mining.js": 26214,
	"./assets/js/confetti": 19342,
	"./assets/js/confetti.js": 19342,
	"./assets/js/eventBus": 1093,
	"./assets/js/eventBus.js": 1093,
	"./assets/js/fireworkEffect": 83034,
	"./assets/js/fireworkEffect.js": 83034,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/pop": 42487,
	"./assets/js/pop.js": 42487,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./assets/js/requestApiCache": 91270,
	"./assets/js/requestApiCache.js": 91270,
	"./assets/js/svg": 23367,
	"./assets/js/svg.js": 23367,
	"./components/layout": 42968,
	"./components/layout.vue": 42968,
	"./components/luckywheel/luckyWheel": 25547,
	"./components/luckywheel/luckyWheel.vue": 25547,
	"./components/luckywheel/luckyWheelItem": 58798,
	"./components/luckywheel/luckyWheelItem.vue": 58798,
	"./components/mBtnFace": 10915,
	"./components/mBtnFace.vue": 10915,
	"./components/mBtnIndex": 34383,
	"./components/mBtnIndex.vue": 34383,
	"./components/mBtnMathine": 50773,
	"./components/mBtnMathine.vue": 50773,
	"./components/mBtnMpay": 64019,
	"./components/mBtnMpay.vue": 64019,
	"./components/mCoinAnim": 69645,
	"./components/mCoinAnim.vue": 69645,
	"./components/mCountUp": 93338,
	"./components/mCountUp.vue": 93338,
	"./components/mEmpty": 69967,
	"./components/mEmpty.vue": 69967,
	"./components/mFirendLeasderBroard": 47453,
	"./components/mFirendLeasderBroard.vue": 47453,
	"./components/mFirendShareOrReward": 66535,
	"./components/mFirendShareOrReward.vue": 66535,
	"./components/mHead": 44359,
	"./components/mHead.vue": 44359,
	"./components/mHeadImg": 82507,
	"./components/mHeadImg.vue": 82507,
	"./components/mLevelProgress": 75422,
	"./components/mLevelProgress.vue": 75422,
	"./components/mLoading": 16007,
	"./components/mLoading.vue": 16007,
	"./components/mLoginRewards": 23614,
	"./components/mLoginRewards.vue": 23614,
	"./components/mLuckyItem": 48761,
	"./components/mLuckyItem.vue": 48761,
	"./components/mMenu": 63008,
	"./components/mMenu.vue": 63008,
	"./components/mPage": 8673,
	"./components/mPage.vue": 8673,
	"./components/mPass": 28481,
	"./components/mPass.vue": 28481,
	"./components/mPopSpinsPriceList": 91602,
	"./components/mPopSpinsPriceList.vue": 91602,
	"./components/mRank": 78562,
	"./components/mRank.vue": 78562,
	"./components/mTab": 44459,
	"./components/mTab.vue": 44459,
	"./components/mTabThree": 15010,
	"./components/mTabThree.vue": 15010,
	"./components/mTabTwo": 39084,
	"./components/mTabTwo.vue": 39084,
	"./components/mTierBenefits": 2331,
	"./components/mTierBenefits.vue": 2331,
	"./components/mUpgradeItem": 67109,
	"./components/mUpgradeItem.vue": 67109,
	"./components/popFaceTip": 83697,
	"./components/popFaceTip.vue": 83697,
	"./components/popGuide": 50923,
	"./components/popGuide.vue": 50923,
	"./components/popPrompt": 52282,
	"./components/popPrompt.vue": 52282,
	"./components/popQuickUpgrade": 12437,
	"./components/popQuickUpgrade.vue": 12437,
	"./components/popReward": 52186,
	"./components/popReward.vue": 52186,
	"./components/ris/risA": 4218,
	"./components/ris/risA.vue": 4218,
	"./components/ris/risB": 98471,
	"./components/ris/risB.vue": 98471,
	"./components/ris/risC": 70070,
	"./components/ris/risC.vue": 70070,
	"./components/slotMachine/mGift": 57587,
	"./components/slotMachine/mGift.vue": 57587,
	"./components/slotMachine/mSlotMachine": 97575,
	"./components/slotMachine/mSlotMachine.vue": 97575,
	"./components/slotMachine/nCurrency": 55771,
	"./components/slotMachine/nCurrency.vue": 55771,
	"./components/slotMachine/nCurrencyTwo": 83532,
	"./components/slotMachine/nCurrencyTwo.vue": 83532,
	"./components/svgIcon": 37115,
	"./components/svgIcon.vue": 37115,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/anim": 82568,
	"./mixins/anim.js": 82568,
	"./mixins/taskMixins": 25868,
	"./mixins/taskMixins.js": 25868,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/assets": 24863,
	"./store/modules/assets.js": 24863,
	"./store/modules/facescan": 22241,
	"./store/modules/facescan.js": 22241,
	"./store/modules/game": 52983,
	"./store/modules/game.js": 52983,
	"./store/modules/task": 72390,
	"./store/modules/task.js": 72390,
	"./store/modules/upgrade": 70401,
	"./store/modules/upgrade.js": 70401,
	"./store/modules/user": 59081,
	"./store/modules/user.js": 59081,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/config/config": 73649,
	"./tonWallet/config/config.json": 73649,
	"./tonWallet/config_for_test/config": 46398,
	"./tonWallet/config_for_test/config.json": 46398,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 41194,
	"./view/": 41194,
	"./view/airdrop": 55342,
	"./view/airdrop.vue": 55342,
	"./view/bot": 15541,
	"./view/bot.vue": 15541,
	"./view/botcode": 99593,
	"./view/botcode.vue": 99593,
	"./view/center": 70138,
	"./view/center.vue": 70138,
	"./view/daily": 4720,
	"./view/daily.vue": 4720,
	"./view/face": 11427,
	"./view/face.vue": 11427,
	"./view/facescan": 81684,
	"./view/facescan.vue": 81684,
	"./view/friends": 54757,
	"./view/friends.vue": 54757,
	"./view/gifts": 28043,
	"./view/gifts.vue": 28043,
	"./view/human": 43541,
	"./view/human.vue": 43541,
	"./view/index": 41194,
	"./view/index.vue": 41194,
	"./view/lucky": 22451,
	"./view/lucky.vue": 22451,
	"./view/pass": 51309,
	"./view/pass.vue": 51309,
	"./view/rank": 62558,
	"./view/rank.vue": 62558,
	"./view/ranks": 1849,
	"./view/ranks.vue": 1849,
	"./view/rewards": 47535,
	"./view/rewards.vue": 47535,
	"./view/ris": 39485,
	"./view/ris.vue": 39485,
	"./view/slotMachine": 80383,
	"./view/slotMachine.vue": 80383,
	"./view/turn": 33853,
	"./view/turn.vue": 33853,
	"./view/upgrade": 5262,
	"./view/upgrade.vue": 5262,
	"./view/walletDetail": 32454,
	"./view/walletDetail.vue": 32454,
	"./view/withdraw": 30963,
	"./view/withdraw.vue": 30963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;